export enum IconName {
  CHECK_CIRCLE = 'check_circle',
  CLOSE = 'close',
  EDIT = 'edit',
  DELETE = 'delete',
  INFO = 'info',
  REMOVE = 'remove',
  ADD = 'add',
  ERROR = 'error',
  CHEVRON_RIGHT = 'chevron_right',
  CHEVRON_LEFT = 'chevron_left',
  ARROW_BACK_IOS = 'arrow_back_ios',
  ARROW_FORWARD_IOS = 'arrow_forward_ios',
  CALL = 'call',
  SEARCH = 'search',
  CHECK = 'check',
  REFRESH = 'refresh',
  GROUP = 'group',
  HOME = 'home',
  ADD_SHOPPING_CART = 'add_shopping_cart',
  EXPAND_LESS = 'expand_less',
  EXPAND_MORE = 'expand_more',
  PRODUCTION_QUANTITY_LIMITS = 'production_quantity_limits',
  TUNE = 'tune',
  LOGOUT = 'logout',
  ARROW_BACK = 'arrow_back',
  SHOPPING_CART_CHECKOUT = 'shopping_cart_checkout',
  MAIL = 'mail',
  PUBLIC = 'public',
  TRAVEL_EXPLORE = 'travel_explore',
  PERSON = 'person',
  SHOPPING_CART = 'shopping_cart',
  ARROW_BACK_IOS_NEW = 'arrow_back_ios_new',
  CALENDAR_MONTH = 'calendar_month',
}
